import { Outlet, createRootRoute } from '@tanstack/react-router'
import { Fragment } from 'react'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import ElectronicSignatureProvider from './-src/providers/electronic-signature.provider'
import ModalMessage from 'components/modal-message'
import ErrorIcon from '../assets/images/ErrorIcon'

export const Route = createRootRoute({
  errorComponent: () => {
    
  return (
    <div>
      <h2>Ocurrió un error {window.location.pathname}</h2>
      <ModalMessage isOpen={true} title="Volvamos a intentarlo" messageBody="Puede que algo no se haya cargado bien. Presiona el botón para que la página se abra correctamente."
      iconElement={<ErrorIcon />} onClose={() => {window.location.reload();}} textButton='Reintentar'/>
    </div>
  )
},
  component: RootComponent,
})

function RootComponent() {
  return (
    <Fragment>
      <ElectronicSignatureProvider>
        <Outlet />
        <div className='fixed bottom-0 right-0 p-4'>
          <TanStackRouterDevtools />
        </div>
      </ElectronicSignatureProvider>
    </Fragment>
  )
}
